import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MainWindowComponent} from './main-window/main-window.component';
import {HeaderComponent} from './header/header.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import {SharedModule} from '../shared/shared.module';
import {RouterModule} from '@angular/router';


@NgModule({
  declarations: [
    HeaderComponent,
    MainWindowComponent,
    SideMenuComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports: [
    HeaderComponent,
    SideMenuComponent,
  ]
})
export class CoreModule { }
